import React, { useState, useEffect, Suspense } from 'react';
import Header from '../components/Layout/Header';
import HeroBanner from '../components/Layout/HeroBanner';
import { FeedSkeleton } from '../components/PostFeed/PostCardSkeleton';
import { useCompactSidebarLayout } from '../hooks/useCompactSidebarLayout';
import './Dashboard.css';
import MobileSidebar from '../components/Layout/mobileSidebar';

const PostFeed = React.lazy(() => import('../components/PostFeed/PostFeed'));
const LeftSidebar = React.lazy(() => import('../components/Layout/LeftSidebar'));
const RightSidebar = React.lazy(() => import('../components/Layout/RightSidebar'));

const Dashboard: React.FC = () => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const isCompactSidebar = useCompactSidebarLayout();

  useEffect(() => {
    if (!isCompactSidebar) {
      setMobileSidebarOpen(false);
    }
  }, [isCompactSidebar]);

  return (
    <div className="dashboard">
      <Header
        onMobileMenuOpen={
          isCompactSidebar ? () => setMobileSidebarOpen(true) : undefined
        }
      />
      <div className="dashboard-content">
        {!isCompactSidebar && (
          <Suspense fallback={null}>
            <LeftSidebar />
          </Suspense>
        )}
        <main className="main-content">
          <HeroBanner />
          <Suspense fallback={<FeedSkeleton count={3} />}>
            <PostFeed />
          </Suspense>
        </main>
        {!isCompactSidebar && (
          <Suspense fallback={null}>
            <RightSidebar />
          </Suspense>
        )}
      </div>
      {isCompactSidebar && mobileSidebarOpen && (
        <MobileSidebar onClose={() => setMobileSidebarOpen(false)} />
      )}
    </div>
  );
};

export default Dashboard;
